module.exports = __webpack_public_path__ + "assets/img/img199.236483cb.png";